import React from 'react';
import { ClockIcon, StarIcon, MapPinIcon, ShieldCheckIcon } from 'lucide-react';
// 04 — TRUST PROOF BAR · [Trust]
// Up to four VERIFIED proof items in a symmetrical card grid. No invented awards.
const proof = [{
  icon: ClockIcon,
  text: 'Helping injured Western Australians since 1990'
}, {
  icon: StarIcon,
  text: '4.6 stars from 231 Google reviews'
}, {
  icon: MapPinIcon,
  text: 'Highgate office with free street parking'
}, {
  icon: ShieldCheckIcon,
  text: 'Free, confidential initial discussion'
}];
export function TrustBar() {
  return <section aria-label="Firm proof points" className="w-full bg-canvas" data-id="element-606">
      <div className="mx-auto w-full max-w-6xl px-5 py-10 sm:px-6 lg:px-8" data-id="element-607">
        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-card border border-ink/5 bg-ink/5 shadow-card sm:grid-cols-2 lg:grid-cols-4" data-id="element-608">
          {proof.map(item => {
          const Icon = item.icon;
          return <div key={item.text} className="flex items-start gap-3 bg-paper p-6" data-id="element-609">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-forest/8 text-forest" data-id="element-610">
                  <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.75} data-id="element-611" />
                </span>
                <p className="pt-1 text-body text-ink" data-id="element-612">{item.text}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}